import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import { useAppDispatch } from "../../../utils/hooks";

interface StatusProfileProps {
  profile_url: string;
  time: string;
  name: string;
  classes?: string;
  currentStatusId: number;
  viewed?: boolean;
}

export default function StatusProfile({
  name,
  profile_url,
  time,
  classes,
  currentStatusId,
  viewed = false,
}: StatusProfileProps) {
  const dispatch = useAppDispatch();

  function handleStatusClick() {
    dispatch(
      updateViewState({
        showStatusModal: true,
        currentStatusId: currentStatusId,
      }),
    );
  }

  return (
    <button
      type="button"
      onClick={handleStatusClick}
      className="flex w-full items-center gap-3 px-3 py-3 text-left transition active:bg-black/[0.03] dark:active:bg-white/[0.04]"
    >
      <img
        src={profile_url}
        className={`h-14 w-14 shrink-0 rounded-full object-cover ${classes ?? ""} ${
          viewed
            ? "ring-2 ring-black/15 ring-offset-2 ring-offset-primary dark:ring-white/25"
            : "ring-[2.5px] ring-[var(--theme-color)] ring-offset-2 ring-offset-primary"
        }`}
        alt=""
      />
      <div className="min-w-0 flex-1">
        <div className="truncate text-[16px] font-semibold capitalize text-darkText">
          {name}
        </div>
        <div className="mt-0.5 truncate text-[13px] text-lightText">{time}</div>
      </div>
    </button>
  );
}
